import React from 'react';
import './ShopPage.css';

const PricingPage: React.FC = () => {
  return (
    <div className="shop-page">
      <h1>Abo Modelle</h1>
      <p>Wähle den passenden Plan für deine Immobilien.</p>

      <div className="pricing-grid">
        {/* FREE */}
        <div className="pricing-card">
          <h2>Free</h2>
          <div className="pricing-price">
            0,00 € <span>/ Monat</span>
          </div>
          <ul className="pricing-features">
            <li>1 Immobilie</li>
            <li>1 Bewertung</li>
            <li>50 MB Speicherplatz</li>
            <li>6 Monate Marktdaten-Historie</li>
          </ul>
        </div>

        {/* LIGHT */}
        <div className="pricing-card">
          <h2>Light</h2>
          <div className="pricing-price">
            4,99 € <span>/ Monat</span>
          </div>
          <ul className="pricing-features">
            <li>Bis zu 3 Immobilien</li>
            <li>Unbegrenzte Bewertungen</li>
            <li>1 GB Speicherplatz</li>
            <li>1 Jahr Marktdaten-Historie</li>
          </ul>
        </div>

        {/* PRO */}
        <div className="pricing-card">
          <h2>Pro</h2>
          <div className="pricing-price">
            12,99 € <span>/ Monat</span>
          </div>
          <ul className="pricing-features">
            <li>Bis zu 10 Immobilien</li>
            <li>Unbegrenzte Bewertungen</li>
            <li>5 GB Speicherplatz</li>
            <li>5 Jahre Marktdaten-Historie</li>
          </ul>
        </div>

        {/* BUSINESS */}
        <div className="pricing-card">
          <h2>Business</h2>
          <div className="pricing-price">
            49,99 € <span>/ Monat</span>
          </div>
          <ul className="pricing-features">
            <li>Unbegrenzte Immobilien</li>
            <li>Unbegrenzte Bewertungen</li>
            <li>20 GB Speicherplatz</li>
            <li>10 Jahre Marktdaten-Historie</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
